module.exports = __webpack_public_path__ + "img/volleyball.f2f372cc.svg";